import { DEFAULT_SHOULD_COLLECT_API_ERROR } from '../../core/constant';
export var getCurrentTimeStamp = function () { return +new Date(); };
export var getShouldCollectApiError = function (baseConfig, requestConfig) {
    var logConfig = (baseConfig || {}).logConfig;
    var globalShouldCollectApiError = (logConfig || {}).shouldCollectApiError;
    var customShouldCollectApiError = (requestConfig || {}).shouldCollectApiError;
    var shouldCollectApiError = customShouldCollectApiError || globalShouldCollectApiError || DEFAULT_SHOULD_COLLECT_API_ERROR;
    return shouldCollectApiError;
};
//# sourceMappingURL=utils.js.map